import { Checkbox, DataSource, Layout, Switch, Textbox } from "@mcleod/components";

export abstract class AutogenLayoutFreightMatchingUser extends Layout {
    checkboxFmCanViewMetadata: Checkbox;
    checkboxRequireTracking: Checkbox;
    sourceFreightMatchingUsers: DataSource;
    switchIsActive: Switch;
    textboxDfmProvider: Textbox;
    textboxFmAccountId: Textbox;
    textboxFmAuthType: Textbox;
    textboxFmBearerToken: Textbox;
    textboxFmPassword: Textbox;
    textboxFmProfileId: Textbox;
    textboxFmUsername: Textbox;
    textboxFmWebhookUrl: Textbox;
    textboxId: Textbox;
    textboxUserGroup: Textbox;
    textboxWebPassword: Textbox;
}
